import {Routes, Route, Navigate} from 'react-router-dom';
import AuthGuard from '../auth/AuthGuard';
import RoleGuard from '../auth/RoleGuard';
import Layout from '../components/Layout';
import {diagnosticsRoutes} from './routesConfig';

import DiagnosticsDashboard from "../pages/diagnostics/Dashboard";
import RealEstate from '../pages/diagnostics/RealEstate';
import PurchaseOrders from '../pages/diagnostics/PurchaseOrders';
import PurchaseOrder from '../pages/diagnostics/PurchaseOrder';
import DocumentsProcess from '../pages/diagnostics/DocumentsProcess';
import ImportBatches from '../pages/diagnostics/ImportBatches';
import ImportDocuments from '../pages/diagnostics/ImportDocuments';
import DiagnosticsReporting from '../pages/diagnostics/Reporting';
import News from '../pages/diagnostics/News';

// import SurveyDashboard from '../pages/survey/Dashboard';
import Surveys from "../pages/survey/Surveys";
import SurveyParticipations from "../pages/survey/SurveyParticipations";
import SurveyParticipation from "../pages/survey/SurveyParticipation";
import ReportingPage from "../pages/survey/ReportingPage";

const AppRoutes = () => (
    <AuthGuard>
        <Layout>
            <Routes>
                {/* Racine */}
                <Route path="/" element={<Navigate to="/enquetes/participations" replace/>}/>

                {/* Enquêtes */}
                {/*<Route path="/enquetes" element={<SurveyDashboard/>}/>*/}

                <Route path="/enquetes/surveys" element={
                    <RoleGuard roles={['survey.read']}>
                        <Surveys/>
                    </RoleGuard>
                }/>
                <Route path="/enquetes/participations" element={
                    <RoleGuard roles={['survey-participation.read']}>
                        <SurveyParticipations/>
                    </RoleGuard>
                }/>
                <Route path="/enquetes/reporting" element={
                    <RoleGuard roles={['reporting']}>
                        <Navigate to="/enquetes/reporting/synthese" replace/>
                    </RoleGuard>
                }/>
                <Route path="/enquetes/reporting/:reportId" element={
                    <RoleGuard roles={['reporting']}>
                        <ReportingPage/>
                    </RoleGuard>
                }/>

                <Route path="/enquetes/:surveyId/participations" element={
                    <RoleGuard roles={['survey-participation.read']}>
                        <SurveyParticipations/>
                    </RoleGuard>
                }/>
                <Route path="/enquetes/:surveyId/participations/:participationId" element={
                    <RoleGuard roles={[]}>
                        <SurveyParticipation/>
                    </RoleGuard>
                }/>

                {/* Diagnostics */}
                <Route path="/diagnostics" element={<DiagnosticsDashboard/>}/>
                <Route path="/diagnostics/patrimoine" element={
                    <RoleGuard roles={diagnosticsRoutes.find(r => r.path === '/diagnostics/patrimoine').roles}>
                        <RealEstate/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/bons-de-commande" element={
                    <RoleGuard roles={diagnosticsRoutes.find(r => r.path === '/diagnostics/bons-de-commande').roles}>
                        <PurchaseOrders/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/bon-de-commande" element={
                    <RoleGuard roles={['purchase-order.read']}>
                        <PurchaseOrder/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/documents-entrants" element={
                    <RoleGuard roles={['inbound-document.read']}>
                        <DocumentsProcess/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/lots-d-import" element={
                    <RoleGuard roles={[]}>
                        <ImportBatches/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/import-de-documents" element={
                    <RoleGuard roles={[]}>
                        <ImportDocuments/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/reporting" element={
                    <RoleGuard roles={['reporting']}>
                        <DiagnosticsReporting/>
                    </RoleGuard>
                }/>
                <Route path="/diagnostics/news" element={
                    <RoleGuard roles={[]}>
                        <News/>
                    </RoleGuard>
                }/>

                <Route path="*" element={<Navigate to="/enquetes/participations" replace/>}/>
            </Routes>
        </Layout>
    </AuthGuard>
);

export default AppRoutes;